const transform = num => {
    return {
        MozTransformStyle: num,
        WebkitTransform: num,
        OTransform: num,
        msTransform: num,
        transform: num,
    };
};

export { transform };
